import { fmtDateTime } from '../../shared/format';
import { Badge } from '../../shared/ui';
import type { SyncReport } from '../types';

/** Resultado de un repaso de SAP: cuándo, qué encontró y qué hizo. */
export function SyncReportView({ report }: { report: SyncReport }): JSX.Element {
  const items: Array<[string, number]> = [
    ['Pedidos abiertos', report.openOrders],
    ['Publicados', report.published],
    ['Modificados', report.modified],
    ['Recordatorios', report.reminders],
    ['Cerrados', report.closed],
    ['Resúmenes', report.digests],
    ['Correos enviados', report.mail?.sent ?? 0],
    ['Correos fallidos', report.mail?.failed ?? 0],
  ];
  return (
    <div className="stack sm">
      <div className="row">
        {report.ok ? <Badge tone="ok">Correcto</Badge> : <Badge tone="bad">Con error</Badge>}
        <span className="muted">{fmtDateTime(report.at)}</span>
        {report.silent ? <Badge plain tone="info">Primer repaso: publica sin avisar</Badge> : null}
      </div>
      {report.error ? <div className="callout bad">{report.error}</div> : null}
      <dl className="sync-grid">
        {items.map(([label, n]) => (
          <div key={label} className={label === 'Correos fallidos' && n > 0 ? 'bad' : ''}>
            <dt>{label}</dt>
            <dd className="num">{n}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
